import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';

import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import { CommonService } from '../../../../shared/services/common.service';
import { arrayNotEmptyValidator } from '../../../../shared/validators/array-not-empty-validator';
import { distinctUntilChanged, pairwise, startWith, take, takeUntil, tap } from 'rxjs/operators';
import { GoogleMapsService } from 'src/app/shared/services/google-maps.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { TimeValidationService } from 'src/app/bookings/shared/time-validation.service';
import { CreateBookingService } from '../../create-booking.service';
import { FormConstants } from '../../../../core/globals/form-constants';
import { Subject, combineLatest } from 'rxjs';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import moment from 'moment';

@Component({
  selector: 'app-cab-form',
  templateUrl: './cab-form.component.html',
  styleUrls: ['./cab-form.component.scss', '../../../../shared/styles/form.scss']
})
export class CabFormComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() config: any;
  @Input() userDetails: any;
  @Input() formDetails: FormGroup;
  @Input() dateControl: FormControl;
  @Input() referenceBooking: any;
  @Input() dateEditable: boolean;
  @Input() miscellConfig: any;
  @Input() workflowConfig: any;
  @Input() configComplete: any;
  @Input() designationConfig: any;

  public formError = FormConstants.errorMessages.formError;
  public stopConfig: any;
  public twelveHour;
  public startConfig: any;
  public endConfig: any;
  public riderConfig: any;
  public boardingChangeMessage: string;
  isLoading = false;
  cabTypeList = [];
  riderCabList = [];
  newRiderCabList: any = {
    allocatedVehicle: [],
    allVehicle: [],
    highCapacity:[]
  };
  public boardingOptions = [
    {
      label: 'Pick Up',
      value: 'PickUp',
      icon: 'assets/pickup.svg'
    },
    {
      label: 'Drop Off',
      value: 'Drop',
      icon: 'assets/drop-point.svg'
    }
  ];
  private watchers = [];
  private destroy$ = new Subject();

  public savedLocations: any[];
  public stopRidersEditActive = [];
  public riderNameMap: any = {};
  public startRiderConfig: any;
  public addStopConfig: any;
  public removeStopConfig: any;
  public multiMidDayConfig: any;
  public vendorConfig: any;
  public vendorList: any;
  private cutoff: any;
  private airports: any;
  private cityStationMap:any=[]
  public isStartAirportOnly: boolean;
  public isEndAirportOnly: boolean;
  public isAirportToAirport: boolean;
  private actionControlConfig: any[] = [];
  public editModeControlHide: any = {};
  public bookingEditConfigObj: any;
  public reasonText: any;
  public minChar: any;
  maxChar;
  selectedPayerPersonId: any;
  showDialog: boolean;
  showDialog1: boolean;
  riderGuidList = [];
  enableDesignationBasedVehicle = false;
  enableCityOfficeAddress = false;
  cityOfficeMappedData = [];
  marshallAllocated = true;
  toastTimer = false;
  DesignationBasedVehicleAllocation: string;
  isBookingTypePresent = true;
  isCityPresent = true;
  isGenderPresentInConfig = true;
  isInTimeRange = true;
  enablePredictiveStopTime = false;
  disableTimePicker = true;
  showHighCapacityPopup:boolean = false;

  public tabDetails = [
  ];
  public tabValue = 'One day Trip';
  multidayUI = false;
  multiDaysCount: any = [];
  multidaysArray: any;
  multidayBookingType = [];
  roundTripBookingType=[]
  showSwitch = false;
  editBooking = false;
  myForm: FormGroup;
  // marshallNeeded:boolean=false
  tooltipContent: string[] = [];
  escortConfig: EscortAssignmentConfig;
  startTime: string;
  endTime: string;
  isGenderPresent = false;
  escortGender: string[] = [];
  disableMarshallInDayHours = false;
  preSelectedCab: string;
  isHovered = false;
  isEscortDisabled = true;
  roundTrip:boolean=false
  getCutoffConfig:any

  constructor(private commonService: CommonService, private googleMapsService: GoogleMapsService,
              private changeDetectorRef: ChangeDetectorRef, private utilService: UtilService,
              private commonBookingService: CommonBookingService, private authService: AuthService,
              private timeValidationService: TimeValidationService, public createBookingService: CreateBookingService) {
    super();
  }

  @Input()
  set bookingEditConfig(bookingEditConfig: any) {
    if (bookingEditConfig) {
     this.editBooking = true;
     this.disableTimePicker = false;
     this.bookingEditConfigObj = bookingEditConfig;
     this.recheckButtonVisibility();
    }
  }

  recheckButtonVisibility = () => {
    if (this.bookingEditConfigObj) {
      this.actionControlConfig.forEach((config) => {
        this.editModeControlHide[config.elementKey] = !this.checkButtonVisibilityForEdit(config, this.bookingEditConfigObj);
      });
    }
  }

  setCabTypeBasedOnDesignation() {
    let matchedRider;
    for (const designation of this.designationConfig.designations) {
      matchedRider = this.userDetails.riders.find((rider) => {
        if (rider.riderType === 'Guest') {
          rider.designation = 'Guest';
        }
        return rider.designation === designation;
      });
      if (matchedRider) { break; }
    }
    if (matchedRider) {
      this.cabTypeList = this.designationConfig.cabTypes[matchedRider.designation];
    }
    if (this.cabTypeList.length > 0) {
      const index = this.cabTypeList.findIndex((type) => type === this.formDetails.get('vehicleType').value);
      if (index === -1) {
        this.formDetails.get('vehicleType').setValue('');
      }
    }
    this.isLoading = false;
  }

  ngOnInit() {
    
    if (this.formDetails.get('city').value != '' && this.formDetails.get('spotBookingType').value != '') { this.disableTimePicker = false; }
    this.enableDesignationBasedVehicle = this.workflowConfig?.enableDesignationBasedVehicle;
    if (this.enableDesignationBasedVehicle) {
         if (this.formDetails.get('city').value){
          this.preSelectedCab = this.formDetails.get('vehicleType').value;
          this.createBookingService.riderGuid.subscribe(res => this.riderGuidList = res);
          this.commonService.getRiderCab(this.riderGuidList, this.formDetails.get('city').value,this.riderGuidList?.length).subscribe(res =>
            {this.riderCabList = res;
             this.newRiderCabList = res;
            }
          );
         }
          else {
            this.formDetails.get('city').valueChanges.pipe(distinctUntilChanged()).subscribe(valueCity => {
              if (valueCity){
              this.createBookingService.riderGuid.subscribe(res => this.riderGuidList = res);
              this.commonService.getRiderCab(this.riderGuidList, valueCity,this.riderGuidList?.length).subscribe(res =>
                {this.riderCabList = res;
                 this.newRiderCabList = res;
                }
              );
              }
            });
          }
      }


   


    const selectedPayerRider = this.userDetails.riders.find((rider) => !!rider.payerGuid);
    this.selectedPayerPersonId = selectedPayerRider ? selectedPayerRider['travellerId'] : null;
    this.commonService.fetchAirports().subscribe((response: any) => {
      this.airports = response;
    });
    if (this.designationConfig?.designationBasedCabType) {
        this.setCabTypeBasedOnDesignation();
      } else {
        this.isLoading = false;
      }

    this.stopConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Stop Address Form');
    this.vendorConfig = this.commonService.getConfigForElementKey(this.configComplete, 'vendor');
    this.startConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Start Address Form');
    this.endConfig = this.utilService.deepCopy(this.commonService.getConfigForElementKey(this.configComplete, 'End Address Form'));
    this.riderConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Stop Riders List Form')?.elementConfigList || [];
    this.startRiderConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Start Riders List Form')?.elementConfigList || [];
    this.addStopConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Add Stop');
    this.removeStopConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Remove Stop');
    this.multiMidDayConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Multi mid-day Form');


    this.actionControlConfig.push(
        this.addStopConfig,
        this.removeStopConfig,
        this.commonService.getConfigForElementKey(this.stopConfig, 'Remove Rider'),
        this.commonService.getConfigForElementKey(this.stopConfig, 'Add Rider'),
      );
    this.recheckButtonVisibility();


    const stops = this.formDetails.get('stops');
    if (this.formDetails.controls.stops && this.formDetails.controls.stops.value[0].time)
      {
        const pickupTime = this.convertTime(this.formDetails.controls.stops.value[0].time);
        // this.checkMarshallTime(pickupTime);
      }
    if (!stops) {
        this.formDetails.addControl('stops', new FormArray([]));
        this.addStartPoint();
        this.addEndPoint();
      } else if (stops instanceof FormArray) {
        for (let stopIndex = 0; stopIndex < stops.length; stopIndex++) {
          const stop = stops.at(stopIndex);
          this.stopRidersEditActive.push(false);
          if (stop instanceof FormGroup) {
            if (stopIndex === 0) {
           
                if (this.formDetails.get('spotBookingType').value) {
                  if (this.miscellConfig.enableCityWiseCreationCutOff){
                    this.commonService.fetchCityCutoff().subscribe((respone) => {
                      this.getCutoffConfig=respone
                      this.resetPickupCutOff(respone, stop, this.formDetails.get('spotBookingType').value, this.formDetails.get('city').value);
                      this.findCutoffTimeForBookingType(respone, stop);
                    });
                  }
                  else{
                    this.commonService.fetchCutoff().subscribe((respone) => {
                      this.getCutoffConfig=respone
                      this.resetPickupCutOff(respone, stop, this.formDetails.get('spotBookingType').value);
                      this.findCutoffTimeForBookingType(respone, stop);
                    });
                  }
                } else {
                  if (this.miscellConfig.enableCityWiseCreationCutOff) {
                  this.commonService.fetchCityCutoff().subscribe(this.setStartTimeValidator.bind(this, stop));
                  }
                  else {
                  this.commonService.fetchCutoff().subscribe(this.setStartTimeValidator.bind(this, stop));
                  }
                }
             
                this.commonService.fetchEditConfig().subscribe(this.setStartTimeValidator.bind(this, stop));
                    
            }
            if (stop.get('time')) {
              this.watchers.push(
                stop.get('time').valueChanges.pipe(startWith(null), pairwise())
                  .subscribe(this.timeValidationService.stopTimeValidator.bind(this, stops))
              );
            }
            if (stop.get('address')) {
              this.watchers.push(
                stop.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
                  this.cabStopsValidator.bind(this, this.formDetails))
              );
            }
          }
        }
      }

    this.createBookingService.escortConfig.pipe(takeUntil(this.destroy$), ).subscribe(res => {
      this.escortConfig = res;
      this.startTime = this.escortConfig.escortAssigGenderConfig[0].escortAssigTimeConfig.startTime;
      this.endTime = this.escortConfig.escortAssigGenderConfig[0].escortAssigTimeConfig.endTime;
      this.checkEscortAssignment();
      this.addEscortConfigInstruction();
    });
    this.userDetails.riders.forEach((user) => {
      this.riderNameMap[user.travellerId] = user.name;
      this.isGenderPresent = this.isGenderPresent || this.escortGender.includes(user.gender);
    });
    this.commonService.getSavedLocations().subscribe((response: any[]) => {
      this.commonBookingService.savedAddressesForRiders.
        pipe(
          takeUntil(this.destroy$),
        ).
        subscribe((address: any) => {
          if (address) {
            this.savedLocations = [...response, ...address];
          } else {
            this.savedLocations = response;
          }
        });
    });
    this.watchers.push(
      this.formDetails.get('city').valueChanges.pipe(startWith(null), pairwise()).subscribe((res) =>
       { this.cabStopsValidator.bind(this, this.formDetails); this.setCityTypePresent(); this.handleCityChange()}),
      this.formDetails.get('destinationCity').valueChanges.pipe(startWith(null), pairwise()).subscribe(
        this.cabStopsValidator.bind(this, this.formDetails)),
      this.formDetails.get('spotBookingType').valueChanges.pipe(startWith(null), pairwise()).subscribe(
        this.handleBookinTypeChange),
      // this.formDetails.get('vendor').valueChanges.pipe(startWith(null), pairwise()).subscribe(
      //   this.cabStopsValidator.bind(this, this.formDetails))
    );
    if (this.vendorConfig && !this.vendorConfig.config.values.length) {
      this.commonService.getEtsData().subscribe((response) => {
        this.vendorList = response.vendors || [];
      });
    }
    if (this.miscellConfig && this.miscellConfig['minChar']) {
        this.minChar = this.miscellConfig['minChar'];
        this.maxChar = this.miscellConfig['maxChar'];
        this.disableMarshallInDayHours = this.miscellConfig['disableMarshallInDayHours'];
        FormConstants.setMinChar(this.minChar);
      }
    if (this.miscellConfig['12hrTimeFormat'] === "false") {
        this.twelveHour = false;
      }
      else {
        this.twelveHour = true;
      }
    this.enableCityOfficeAddress = this.miscellConfig['enableCityOfficeAddress'];
    this.multidayBookingType = this.miscellConfig['multidayBookingType'];
    this.roundTripBookingType = this.miscellConfig['roundTripBookingType'];
    this.DesignationBasedVehicleAllocation = this.miscellConfig['DesignationBasedVehicleAllocation'];
    if(this.DesignationBasedVehicleAllocation==="CAPACITIVE")
    {
      this.showHighCapacityPopup=this.createBookingService.riderGuid.getValue()?.length>=Number(this.miscellConfig['cabTypeHighCapacityThreshold'])
    }
    this.enablePredictiveStopTime = this.miscellConfig?.enablePredictiveStopTime;

    this.formDetails.get('spotBookingType').valueChanges.pipe(distinctUntilChanged()).subscribe(bookingType => {
      this.showSwitch = false; 
      this.tabDetails = [{
          value: 'One day Trip',
          label: 'One day Trip'
      }]; 
    
      if (this.roundTripBookingType.includes(bookingType)) {
        this.tabDetails.push({
          value: 'Round Trip',
          label: 'Round Trip',
        });
        this.showSwitch = true;
      }

      if (this.multidayBookingType.includes(bookingType)) {
        this.tabDetails.push({
          value: 'Multi-day Trip',
          label: 'Multi-day Trip',
        });
        this.showSwitch = true;
      }
    });

    if (this.multidayBookingType) {
      this.showSwitch = this.multidayBookingType.includes(this.formDetails.get('spotBookingType').value) ? true : false;
      }
    this.createBookingService.multiDayBooking.subscribe(res => {
        if (res) {
          if (this.formDetails.get('multiDays')){
            this.createBookingService.daysCount.next(this.formDetails.get('multiDays').value.length + 1);
            this.multiDaysCount = Array(this.formDetails.get('multiDays').value.length + 1).fill(0);

          }
          this.tabValue = 'Multi-day Trip';
          this.multidayUI = true;
        }
      });

      if(this.editBooking){
        this.tabDetails = [{
          value: 'One day Trip',
          label: 'One day Trip'
        }]; 
        if(this.referenceBooking?.roundTrip ){
          this.tabDetails.push({
            value: 'Round Trip',
            label: 'Round Trip',
          });
          this.tabValue = 'Round Trip';
          this.showSwitch=true
          if(this.formDetails.get('spotBookingType').value.toLowerCase().includes('outstation')) this.formDetails.get('destinationCity').disable()
        }
        if (this.referenceBooking.multiDayBooking){
          this.tabDetails.push({
            value: 'Multi-day Trip',
            label: 'Multi-day Trip',
          });
          this.tabValue = 'Multi-day Trip';
          this.disableTimePicker = false;
          this.multidaysArray = this.formDetails.get('multiDays');
          this.createBookingService.daysCount.next(this.referenceBooking.noOfDays);
          this.createBookingService.multiDayBooking.next(this.referenceBooking.multiDayBooking);
          this.multiDaysCount = Array(+this.referenceBooking.noOfDays).fill(0);
          this.multidayUI = true;
        }
      }
      // fetch escort config
            }

      findCutoffTimeForBookingType(cutoffConfig, startFormGroup) {
        combineLatest([
          this.formDetails.get('spotBookingType').valueChanges,
          this.formDetails.get('city').valueChanges
        ]).pipe(
          takeUntil(this.destroy$)
        ).subscribe(([spotBookingType, city]) => {
          if (this.miscellConfig?.enableCityWiseCreationCutOff && city && spotBookingType) {
            this.disableTimePicker = false;
            this.resetPickupCutOff(cutoffConfig, startFormGroup, spotBookingType, city);
          } else {
            this.disableTimePicker = false;
            this.resetPickupCutOff(cutoffConfig, startFormGroup, spotBookingType);
          }
        });

  }

  addEscortConfigInstruction()
  {
    if(this.escortConfig?.instructions && Array.isArray(this.escortConfig.instructions)){
      this.escortConfig.instructions.forEach((instruction) => {
        this.tooltipContent.push(instruction);
      });
    }
  }
  convertTime(time12h) {
    const [time, period] = time12h.split(' ');
    let [hours, minutes] = time.split(':');

    hours = parseInt(hours);
    minutes = parseInt(minutes);

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    }

    if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    const hours24h = hours.toString().padStart(2, '0');
    const minutes24h = minutes.toString().padStart(2, '0');

    return `${hours24h}:${minutes24h}`;
  }

  isTimeInRange(startTime, endTime, timeToCheck) {
    if (!timeToCheck || timeToCheck?.length < 1)
    {
      return false;
    }

    const isStartTime12Hour = startTime.toLowerCase().includes('am') || startTime.toLowerCase().includes('pm');
    const isEndTime12Hour = endTime.toLowerCase().includes('am') || endTime.toLowerCase().includes('pm');
    const isTimeToCheck12Hour = timeToCheck.toLowerCase().includes('am') || timeToCheck.toLowerCase().includes('pm');

   
    if (isStartTime12Hour) {
      startTime = this.convertTo24Hour(startTime);
  }
  if (isEndTime12Hour) {
      endTime = this.convertTo24Hour(endTime);
  }
  if (isTimeToCheck12Hour) {
      timeToCheck = this.convertTo24Hour(timeToCheck);
  }

  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);
  const [checkHour, checkMinute] = timeToCheck.split(':').map(Number);

  if (endHour < startHour || (endHour === startHour && endMinute < startMinute)) {
      return (
            (checkHour < endHour || (checkHour === endHour && checkMinute <= endMinute)) ||
             (checkHour > startHour || (checkHour === startHour && checkMinute >= startMinute))
        );
  } else {
      return (
            (checkHour > startHour || (checkHour === startHour && checkMinute >= startMinute)) &&
             (checkHour < endHour || (checkHour === endHour && checkMinute <= endMinute))
        );
  }
    }

    convertTo24Hour(time12h) {
      return moment(time12h, 'h:mm A').format('HH:mm');
  }
  

  resetPickupCutOff(cutoffConfig, startFormGroup, value, city?) {
        
    this.cutoff = null;
    if (cutoffConfig?.bookingTypeConfig) {

      if (this.miscellConfig?.enableCityWiseCreationCutOff){
        const cityData = cutoffConfig.bookingTypeConfig[city];
        if (cityData) {
          for (const bookingType of cityData) {
            if (bookingType['bookingTypes']) {
              if (bookingType['bookingTypes'].findIndex((types) => value.toLowerCase() === types.toLowerCase()) !== -1) {
                this.cutoff = bookingType['cutOffMins'];
                break;
              }
            }
          }
        }
      }
      else{
        for (const bookingType of cutoffConfig.bookingTypeConfig) {
        if (value) {
          if (bookingType["bookingTypes"].findIndex((types) => value.toLowerCase() === types.toLowerCase()) !== -1) {
            this.cutoff = bookingType["cutOffMins"];
            break;
          }
        }
      }
      }
    }
    const validators = [];
    if (this.commonService.getConfigForElementKey(this.startConfig, 'time').config.mandatory) {
      validators.push(Validators.required);
    }
    validators.push(this.pickupTimeValidate);
    startFormGroup.get('time').setValidators(validators);
    startFormGroup.controls['time'].updateValueAndValidity();
  }

  resetEditPickupCutOff(startFormGroup) {
        this.cutoff = this.bookingEditConfigObj.pickUpTime;
    const validators = [];
    validators.push(this.pickupTimeValidate);
    startFormGroup.get('time').setValidators(validators);
    startFormGroup.controls['time'].updateValueAndValidity();
  }

  timeChangeCallback(time) {
    // this.checkMarshallTime(time);
    this.setTimeInRange();
    if (this.createBookingService.isEditMode) {
      this.cutoff = this.bookingEditConfigObj.pickUpTime;
      // this.resetEditPickupCutOff(this.formDetails.get('stops')['controls'][0]);
      this.resetPickupCutOff(this.getCutoffConfig,this.formDetails.get('stops')['controls'][0],this.formDetails.get('spotBookingType').value,this.formDetails.get('city').value)
      // this.resetPickupCutOff()
    }
  }

  setStartTimeValidator = (startFormGroup, response) => {
    this.findCutoffTimeForBookingType(response, startFormGroup);
    const validators = [];
    if (this.commonService.getConfigForElementKey(this.startConfig, 'time').config.mandatory) {
      validators.push(Validators.required);
    }
    validators.push(this.pickupTimeValidate);
    startFormGroup.get('time').setValidators(validators);
  }

  handleBookinTypeChange = ([prev, next]: [string, string]) => {
    if (this.enableCityOfficeAddress && this.formDetails.get('city').value && this.formDetails.get('spotBookingType').value && this.riderGuidList.length > 0) {
      this.commonService.getCityOfficeMapping(this.formDetails.get('city').value, this.riderGuidList).subscribe(res => {
        res.forEach(item => item['isSaved'] = true);
        this.cityOfficeMappedData = res;
      });
    }

    // Resetting all formControl of fields which are not visible
    Object.keys(this.formDetails.controls).forEach((controlKey)=>{
      if(this.formDetails.get(controlKey) instanceof FormControl){
        if(this.config && this.formDetails && this.getConfigForElementKey(this.config, controlKey) && 
          !this.checkVisibility(this.getConfigForElementKey(this.config, controlKey).config, this.formDetails)){
          this.formDetails.get(controlKey).reset();
        }
      }
    });

    if (next !== 'Outstation') {
      if (this.formDetails.get('destinationCity') && this.formDetails.get('destinationCity').value) {
        this.formDetails.get('destinationCity').setValue('');
      }
    }
    this.isStartAirportOnly = false;
    this.isEndAirportOnly = false;
    this.isAirportToAirport = false;
    const stops = this.formDetails.get('stops');
    if (stops instanceof FormArray) {
      if (next === 'Airport PickUp') {
        this.isStartAirportOnly = true;
        const start = stops.at(0);
        if (start instanceof FormGroup && start.get('address').value && !start.get('address').value.isAirport) {
          start.get('address').reset();
        }
      } else if (next === 'Airport Drop') {
        this.isEndAirportOnly = true;
        const end = stops.at(stops.length - 1);
        if (end instanceof FormGroup && end.get('address').value && !end.get('address').value.isAirport) {
          end.get('address').reset();
        }
      }
      else if (next === 'Bus Station Pickup' || next === 'Railway Station Pickup') {
        this.isStartAirportOnly = true;
        this.getTransPortData(this.formDetails.get('city').value,next)
        const start = stops.at(0);
        if (start instanceof FormGroup && start.get('address').value && !start.get('address').value.isBusRailway) {
          start.get('address').reset();
        }
      }
      else if (next === 'Bus Station Drop' || next === 'Railway Station Drop') {
        this.getTransPortData(this.formDetails.get('city').value,next)
        this.isEndAirportOnly = true;
        const end = stops.at(stops.length - 1);
        if (end instanceof FormGroup && end.get('address').value && !end.get('address').value.isBusRailway) {
          end.get('address').reset();
        }
        
      }
       else if (next === 'Airport To Airport') {
        this.isAirportToAirport = true; 
        const both = stops.at(stops.length - 1);
        if (both instanceof FormGroup && both.get('address').value && !both.get('address').value.isAirport) {
          both.get('address').reset();
        }
      }
    }

    if( this.tabValue=='Round Trip' && this.formDetails.get('spotBookingType').value.toLowerCase().includes('outstation')){
      this.formDetails.get('destinationCity').setValue(this.formDetails.get('city').value)
      this.formDetails.get('destinationCity').disable()  
    }    
    this.setEndStopValidator([prev, next]);
    this.setBookingTypePresent();
    // this.selectedCityBokkingType.next({...this.selectedCityBokkingType.getValue(),bookingType:next})
  }

  pickupTimeValidate = (control) => {    
    return this.timeValidationService.pickupTimeValidator(this.dateControl, this.cutoff, control);
  }

  addStartPoint() {
    // Initiate rider array
    const startRidersMandatory = this.commonService.getConfigForElementKey(this.startConfig, 'riders').config.mandatory;
    const ridersArray = new FormArray([], startRidersMandatory ? [arrayNotEmptyValidator] : undefined);

    // set up start point form
    const startFormGroup = new FormGroup({});
    this.constructForm(startFormGroup, (this.startConfig?.elementConfigList || []));
    startFormGroup.setControl('riders', ridersArray);

    // Add all riders as picked up at start point
    this.userDetails.riders.forEach((rider: any) => {
      const riderPatch = {
        name: rider.travellerId,
        mobile: rider.mobile,
        boardingType: 'PickUp'
      };
      this.addRider(startFormGroup, 0, riderPatch);
    });
    const stops = this.formDetails.get('stops');
    if (stops instanceof FormArray) {
      stops.push(startFormGroup);
    }
    if (this.miscellConfig?.enableCityWiseCreationCutOff) {
    this.commonService.fetchCityCutoff().subscribe(this.setStartTimeValidator.bind(this, startFormGroup));
    }
    else {
    this.commonService.fetchCutoff().subscribe(this.setStartTimeValidator.bind(this, startFormGroup));
    }
    this.stopRidersEditActive.push(false);
    if (startFormGroup.get('time') instanceof FormControl) {
      this.watchers.push(
        startFormGroup.get('time').valueChanges.pipe(startWith(null), pairwise())
          .subscribe(this.timeValidationService.stopTimeValidator.bind(this, stops))
      );
    }
    if (startFormGroup.get('address')) {
      this.watchers.push(
        startFormGroup.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
          this.cabStopsValidator.bind(this, this.formDetails))
      );
    }
  }

  addEndPoint() {
        const endFormGroup = new FormGroup({});
    this.constructForm(endFormGroup, (this.endConfig?.elementConfigList || []));
    const stops = this.formDetails.get('stops');
    if (stops instanceof FormArray) {
      stops.push(endFormGroup);
    }
    if (endFormGroup.get('time') instanceof FormControl) {
      this.watchers.push(
        endFormGroup.get('time').valueChanges.pipe(startWith(null), pairwise())
          .subscribe(this.timeValidationService.stopTimeValidator.bind(this, stops))
      );
    }
    if (endFormGroup.get('address')) {
      this.watchers.push(
        endFormGroup.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
          this.cabStopsValidator.bind(this, this.formDetails))
      );
    }
  }


  addStop(index: number) {
       const stopRidersMandatory = this.commonService.getConfigForElementKey(this.stopConfig, 'riders').config.mandatory;
    const ridersArray = new FormArray([], stopRidersMandatory ? [arrayNotEmptyValidator] : undefined);

    const stopFormGroup = new FormGroup({});

    this.constructForm(stopFormGroup, (this.stopConfig?.elementConfigList || []));
    stopFormGroup.setControl('riders', ridersArray);
    const stops = this.formDetails.get('stops');
    if (stops instanceof FormArray) {
      stops.insert(index, stopFormGroup);
    }
    this.stopRidersEditActive.splice(index, 0, false);

    if (stopFormGroup.get('time') instanceof FormControl) {
      this.watchers.push(
        stopFormGroup.get('time').valueChanges.pipe(startWith(null), pairwise())
          .subscribe(this.timeValidationService.stopTimeValidator.bind(this, stops))
      );
    }
    if (stopFormGroup.get('address')) {
      this.watchers.push(
        stopFormGroup.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
          this.cabStopsValidator.bind(this, this.formDetails))
      );
    }


    if (this.multidayUI){
      this.constructForm(stopFormGroup, (this.stopConfig?.elementConfigList || []));
      const stops = this.formDetails.get('stops');
      if (stopFormGroup.get('address')) {
        this.watchers.push(
          stopFormGroup.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
            this.cabStopsValidator.bind(this, this.formDetails))
        );
      }
    }
  }

  addMidStop(index: number, day: number){
  const stops = this.formDetails.get('multiDays') as FormArray;

  for (let i = 0; i < stops.length; i++) {
    const currentGroup = stops.at(i) as FormGroup;
    const currentDay = currentGroup.get('day')?.value;

    if (currentDay == day) {
        const newGroup = new FormGroup({
          address: new FormControl(''),
          geoArea: new FormControl(''),
        });

        const stopsArray = currentGroup.get('stops') as FormArray;
        stopsArray.push(newGroup);
      }
  }
}

  removeStop(index: number) {
    const stops = this.formDetails.get('stops');
    const removedStopValue = stops['controls'][index];
    const idx = removedStopValue.get('riders')['controls'].findIndex((rider) => {
      return this.selectedPayerPersonId === rider.get('name').value && rider.get('boardingType').value === 'PickUp';
    });
    if (this.selectedPayerPersonId && idx !== -1 && !this.multidayUI) {
      this.showDialog1 = true;
    } else {
      if (stops instanceof FormArray) {
        stops.removeAt(index);
      }
      this.stopRidersEditActive.splice(index, 1);
    }
  }

  removeMidStop(index: number, day: number){
    const stops = this.formDetails.get('multiDays') as FormArray;
    for (let i = 0; i < stops.length; i++) {
      const currentGroup = stops.at(i) as FormGroup;
      const currentDay = currentGroup.get('day')?.value;
      if (currentDay == day) {
        const stopsArray = currentGroup.get('stops') as FormArray;
        for (let j = 0; j < stopsArray.length; j++) {
          if (index === j && stopsArray.length == 1){
            stops.removeAt(i);
            this.multiDaysCount = Array(stops.controls.length).fill(0);
            this.createBookingService.daysCount.next(this.multiDaysCount.length + 1);
            this.multidaysArray.controls.forEach((formGroup: FormGroup, index: number) =>
              formGroup.get('day').setValue(index + 2)
            );
            break;
          }
          else if (index === j) {
            stopsArray.removeAt(j);
            break;
          }
        }
      }
    }
  }

  addRider(stopForm: FormGroup, stopIndex: number, riderPatch?: any) {
    const riderFormGroup: any = new FormGroup({});
    this.constructForm(riderFormGroup, this.getRiderConfig(stopIndex));
    if (riderPatch) {
      riderFormGroup.patchValue(riderPatch);
    }
    if (!riderFormGroup.get('boardingType').value) {
        riderFormGroup.get('boardingType').setValue(this.boardingOptions[0].value);
        riderFormGroup.get('name').setValue(this.userDetails.riders[0].travellerId);
      }
    riderFormGroup.get('boardingType');
    const riders = stopForm.get('riders');
    if (riders instanceof FormArray) {
      riders.push(riderFormGroup);
    }
  }

  getRiderConfig(stopIndex: number) {
    return stopIndex > 0 ? this.riderConfig : this.startRiderConfig;
  }

  removeRider(riderIndex: number, stopForm: FormGroup) {
    if (this.selectedPayerPersonId && stopForm.get('riders')['controls'][riderIndex].get('boardingType').value === 'PickUp'
      && this.selectedPayerPersonId === stopForm.get('riders')['controls'][riderIndex].get('name').value) {
      this.showDialog = true;
    } else {
      const riders = stopForm.get('riders');
      if (riders instanceof FormArray) {
        riders.removeAt(riderIndex);
      }
    }
  }

  closeDialog() {
    this.showDialog = false;
    this.showDialog1 = false;
  }

  resetForm() {
    const stops = this.formDetails.get('stops');
    if (stops instanceof FormArray) {
      for (let index = 1; index < stops.length - 1; index++) {
        stops.removeAt(index);
      }
      const start = stops.at(0);
      if (start instanceof FormGroup) {
        const riders = start.get('riders');
        if (riders instanceof FormArray) {
          for (let index = 0; index <= riders.length - 1; index++) {
            riders.removeAt(0);
          }
        }

      }
      stops.at(0).reset();
      stops.at(1).reset();
    }

    this.formDetails.reset();
  }

  isTableCellVisible(config: any): boolean {
    return Boolean(config.config.visibility.elementKey || config.config.visibility.visible);
  }

  toggleRidersView(stopIndex: number) {
    this.stopRidersEditActive[stopIndex] = !this.stopRidersEditActive[stopIndex];
  }

  getBoardingLabel(boarding: any): string {
    return boarding.label;
  }

  getBoardingValue(boarding: any): string {
    return boarding.value;
  }

  getImageFromValue = (boarding: any) => {
    for (const option of this.boardingOptions) {
      if (option.value === boarding) {
        return option.icon;
      }
    }
  }

  getRiderLabel(rider: any): string {
    return rider.name;
  }

  getRiderValue(rider: any): string {
    return rider.travellerId || rider.name;
  }

  onRiderChange = (rider: FormGroup, stopIndex: number) => {
    if (!rider.get('name').value) {
      return;
    }

    for (const user of this.userDetails.riders) {
      if (rider.get('name').value === user.travellerId && rider.get('mobile')) {
        rider.get('mobile').setValue(user.mobile);
      }
    }

    const stops = this.formDetails.get('stops');
    const matchesFound = [];

    if (stops instanceof FormArray) {

      for (let sIndex = 0; sIndex < stops['length'] - 1; sIndex++) {
        const stopRiders = stops.at(sIndex).get('riders');
        if (sIndex === stopIndex) {
          continue;
        }
        for (let rIndex = 0; rIndex < stopRiders['length']; rIndex++) {
          const stopRider = stopRiders instanceof FormArray && stopRiders.at(rIndex);
          if (rider.get('name').value === stopRider.get('name').value) {
            matchesFound.push({
              stopIndex: sIndex,
              riderIndex: rIndex,
              boardingType: stopRider.get('boardingType').value,
              riderForm: stopRider
            });
            break;
          }
        }
      }

      const boardingControl = rider.get('boardingType');

      if (!boardingControl.value) {
        if (!matchesFound.length || stopIndex < matchesFound[0].stopIndex) {
          boardingControl.setValue(this.boardingOptions[0].value);
        } else if (stopIndex > matchesFound[matchesFound.length - 1].stopIndex) {
          boardingControl.setValue(this.boardingOptions[1].value);
        }
      }

      if (boardingControl.value && matchesFound.length) {
        for (const match of matchesFound) {
          if (boardingControl.value === match.boardingType) {
            const riders = stops.at(match.stopIndex).get('riders');
            if (riders instanceof FormArray) {
              riders.removeAt(match.riderIndex);
            }
            const stopDescription = stopIndex === 0 ? 'start point' : ((stopIndex === stops['length']) ? 'end point' : ('stop ' + stopIndex));
            this.boardingChangeMessage = `${boardingControl.value} of rider changed to ${stopDescription}`;
          }
        }
      }
    }
  }

  clearBoardingChangeMessage() {
    this.boardingChangeMessage = '';
  }

  showError(formGroup: FormGroup) {
    return Boolean(formGroup && formGroup.dirty && formGroup.invalid);
  }

  getLocationLabel = (location: any) => {
    if(this.roundTrip){
      const stops = this.formDetails.get('stops') as FormArray;
      const firstFormGroup = stops.at(0) as FormGroup;
      const lastFormGroup = stops.at(stops.length - 1) as FormGroup;
      const addressValue = firstFormGroup.get('address')?.value;
      if (lastFormGroup.get('address')?.value !== addressValue) {
        lastFormGroup.get('address').setValue(addressValue);
        this.changeDetectorRef.detectChanges()
      }
    }
    this.changeDetectorRef.detectChanges()
    return location.address;
  }

  getFieldConfig = (index: number) => {
    if (index === 0) {
      return this.startConfig?.elementConfigList || [];
    } else if (index === this.formDetails.get('stops')['length'] - 1) {
      return this.endConfig?.elementConfigList || [];
    } else {
      return this.stopConfig?.elementConfigList || [];
    }
  }

  stopGeoCordValidator(city: string, stopForm: AbstractControl) {
        const address = stopForm.get('address');
    if (address.value && (address.value.geoCord || address.value.city)) {
      this.googleMapsService.checkLocationInCity(city, address.value).subscribe((response) => {
        if (!response) {
          address.setErrors({
            outsideBounds: true
          });
        } else {
          address.setErrors(null);
        }
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  cabStopsValidator(cabForm: FormGroup) {

    const sourceCity = cabForm.get('city').value;
    const destinationCity = cabForm.get('destinationCity').value;
    const bookingType = cabForm.get('spotBookingType').value;
    const stops = cabForm.get('stops');

    if (stops instanceof FormArray && stops.length) {

      if (bookingType && (bookingType.toLowerCase().includes('outstation'))) {
        if (sourceCity) {
          this.stopGeoCordValidator(sourceCity, stops.at(0));
        }
        if (destinationCity) {
          this.stopGeoCordValidator(destinationCity, stops.at(stops.length - 1));
        }
      } else {
        if (sourceCity) {
          for (let i = 0; i < stops.length; i++) {
            const stop = stops.at(i);
            this.stopGeoCordValidator(sourceCity, stop);
          }
        }
      }
    }
  }

  getHiddenOptions(elementKey): any[] {
    if (elementKey === 'destinationCity' && this.formDetails.get('city') && this.formDetails.get('city').value) {
      return [this.formDetails.get('city').value];
    } else if (elementKey === 'city' && this.formDetails.get('destinationCity') && this.formDetails.get('destinationCity').value) {
      return [this.formDetails.get('destinationCity').value];
    }
    return [];
  }

  setEndStopValidator = ([prev, next]: [string, string]) => {
    const nextBookingType = next && next.toLowerCase();
    const prevBookingType = prev && prev.toLowerCase();
    const stops = this.formDetails.get('stops');
    let endStopFrom;
    if (stops instanceof FormArray) {
      endStopFrom = stops.at(stops.length - 1);
    }
    const addressConfig = this.commonService.getConfigForElementKey(this.endConfig, 'address');
    if ((prevBookingType === 'cab at disposal' || nextBookingType === 'cab at disposal')) {
      if (nextBookingType === 'cab at disposal') {
        addressConfig.config.mandatory = false;
        endStopFrom.get('address').setValidators(this.getValidations(addressConfig, endStopFrom));
      } else {
        addressConfig.config.mandatory = true;
        endStopFrom.get('address').setValidators(this.getValidations(addressConfig, endStopFrom));
      }
      endStopFrom.get('address').updateValueAndValidity();
    }
  }

  getCityBoundForStop(stopIndex: number) {
    const sourceCity = this.formDetails.get('city');
    const destinationCity = this.formDetails.get('destinationCity');
    const bookingType = this.formDetails.get('spotBookingType').value;
    const stops = this.formDetails.get('stops');

    if (stops instanceof FormArray) {
      if (bookingType && bookingType.toLowerCase().includes('outstation')) {
        return stopIndex === stops.length - 1 ? destinationCity.value : sourceCity.value;
      } else {
        return sourceCity.value;
      }
    }
  }

  getStops = () => {
    const stops = this.formDetails.get('stops');
    if (this.enablePredictiveStopTime && stops instanceof FormArray){
      for (let i = 1; i < stops.length; i++) {
        const control = stops.controls[i].get('time');
        control.clearValidators();
        control.updateValueAndValidity();
      }
    }

    if (stops instanceof FormArray) {
      const control = stops.controls[stops.length - 1].get('time');
      control.clearValidators();
      control.updateValueAndValidity();
      control.setErrors(null);
      return stops.controls;
    } else {
      return [];
    }
  }

  getMidStops = (dayIndex) => {
    const dayForm = this.formDetails.get('multiDays') as FormArray;

    if (dayForm && dayForm.controls.length > 0){
      const stops = dayForm.at(dayIndex) as FormGroup;
      const dayStop = stops?.controls.stops as FormArray;
      return dayStop instanceof FormArray ? dayStop.controls : [];
    }
  }

  getMidAddress = (stop) => {
    const address = stop.get('stops');
    return address instanceof FormArray ? address.controls : [];
  }
  getVendorValue = (vendor) => {
    return vendor.guid;
  }

  getVendorLabel = (vendor) => {
    return vendor.vendorName;
  }

  getSavedLocations = (stopIndex: number) => {
    const stops = this.formDetails.get('stops');
    const bookingType = this.formDetails.get('spotBookingType');
    const isBusStationPickup = bookingType.value?.toLowerCase() === 'Bus Station Pickup'.toLowerCase();
    const isBusStationDrop = bookingType.value?.toLowerCase() === 'Bus Station Drop'.toLowerCase();
    const isRailwayStationPickup = bookingType.value?.toLowerCase() === 'Railway Station Pickup'.toLowerCase();
    const isRailwayStationDrop = bookingType.value?.toLowerCase() === 'Railway Station Drop'.toLowerCase();
    if (stops instanceof FormArray) {
      if (stopIndex === 0 && bookingType.value?.toLowerCase() === 'Airport PickUp'.toLowerCase()) {
        return this.airports;
      } else if (stopIndex === stops.length - 1 && bookingType.value?.toLowerCase() === 'Airport Drop'.toLowerCase()) {
        return this.airports;
      }
      else if ((stopIndex === 0 && (isBusStationPickup || isRailwayStationPickup)) ||
      (stopIndex === stops.length - 1 && (isBusStationDrop || isRailwayStationDrop))) {
    return this.cityStationMap;
  }
  
      else if ((stopIndex === 0 || stopIndex === stops.length - 1) && bookingType.value?.toLowerCase() === 'Airport To Airport'.toLowerCase()) {
        const stopsSelected = stops.value.filter(stop => stop.address && stop.address.address);
        if (stopsSelected.length > 0) {
          return this.getListOfAirports(stopsSelected);
        } else {
          return this.airports;
        }
      }
    }
    return this.enableCityOfficeAddress ? this.cityOfficeMappedData : this.savedLocations;
  }
  getListOfAirports(stops: Array<object>) {

    const airportsAvl = this.airports.filter(o => o.address !== (stops.length > 1 ? stops[0]['address'].address && stops[1]['address'].address : stops[0]['address'].address));
    return airportsAvl;
  }

  disablebtn(control) {
    this.createBookingService.riderGuid.subscribe(res => this.riderGuidList = res);
    return (!(this.riderGuidList.length == control)) ? true : false;
  }

  onTabChange(e) {
    this.tabValue=e
    this.multidayUI = (e == 'Multi-day Trip')
    this.createBookingService.multiDayBooking.next(this.multidayUI);

    this.roundTrip = (e=='Round Trip') 
    this.createBookingService.roundTrip.next(this.roundTrip);
    if(this.roundTrip){
      const bookingType=this.formDetails.get('spotBookingType').value
      if(bookingType.toLowerCase().includes('outstation'))
      {
        this.formDetails.get('destinationCity').setValue(this.formDetails.get('city').value)
        this.formDetails.get('destinationCity').disable()
      }
    }else this.formDetails.get('destinationCity').enable()

    if (this.multidayUI) {
      this.formDetails.addControl('multiDays', new FormArray([]));
      this.multidaysArray = this.formDetails.get('multiDays') as FormArray;
    }    
  }

  getTotalDays(e) {
    this.multiDaysCount = Array(e).fill(0);
    this.multidaysArray = this.formDetails.get('multiDays') as FormArray;
    if (this.multiDaysCount.length - 1 < this.multidaysArray?.controls.length){
        this.multidaysArray.removeAt(this.multidaysArray?.controls.length - 1);
     }else{
       this.multidaysArray.push(
         new FormGroup({
           day: new FormControl(e),
           stops: new FormArray(
            [
             new FormGroup({
               address: new FormControl(''),
               geoArea: new FormControl(''),
             })
            ]
           )
         })
       );
     }
  }

  getBoardingNumber(riders, boardingType){
   let boardPickup = 0, boardDrop = 0;
   for (const rider of riders){
      const boardingTypeControl = rider.get('boardingType');
      boardingTypeControl.value == 'PickUp' ? boardPickup++ : boardDrop++;
    }
   return boardingType == 'PickUp' ? boardPickup : boardDrop;
  }
  checkEscortAssignment()
  {
  const genderListInRiders = new Set(this.userDetails.riders.map(element => element.gender.toLowerCase()));
  this.isGenderPresentInConfig = this.escortConfig.escortAssigGenderConfig[0].gender.some(gender => genderListInRiders.has(gender.toLowerCase()));

  this.setBookingTypePresent();
  this.setCityTypePresent();
  this.setTimeInRange();


  }


  checkMarshallConfig(): boolean
  {
    return this.isCityPresent && this.isBookingTypePresent && this.isGenderPresentInConfig;
  }
  escortAutoAssigner()
  {
    const allStops = this.formDetails.get('stops').value;
    const stops = allStops.slice(0, allStops.length - 1);
    const isTimeValueEmpty = stops.every((stop: any) => stop['time'] === '');
        const isInDarkHour = stops.some((stop) => this.isTimeInRange(this.startTime, this.endTime, stop['time']));
    if (isInDarkHour && this.checkMarshallConfig() && !isTimeValueEmpty) {
      this.setEscortEnabled(true);
      this.showToast(3000);
    }
    else if (!(this.escortConfig.disableMarshallInDayHours && !(isTimeValueEmpty || isInDarkHour)) && this.isCityPresent && this.isBookingTypePresent)
    {
      this.isEscortDisabled = false;
    }
    else
    {
      this.isEscortDisabled = true;
      this.formDetails.get('guardReq').setValue(false);
    }


  }

  setBookingTypePresent()
  {
    const allData = 'ALL'.toLowerCase();
    const formBookingType = this.formDetails.get('spotBookingType').value?.toLowerCase();
    this.isBookingTypePresent = this.escortConfig.bookingType.some(type => type.toLowerCase() === allData || type.toLowerCase() === formBookingType);
    this.checkEscortState();
  }
  setCityTypePresent()
  {
    const allData = 'ALL'.toLowerCase();
    const formCity = this.formDetails.get('city').value?.toLowerCase();
    this.isCityPresent = this.escortConfig?.city?.some(city => city.toLowerCase() === allData || city.toLowerCase() === formCity);
    this.checkEscortState();
    }

  setTimeInRange()
  {
    const stops = this.formDetails.get('stops').value;
    const isTimeEmpty = stops.every((stop: any) => stop['time'] === '');
    const timeInRange = stops.some((stop) => this.isTimeInRange(this.startTime, this.endTime, stop['time']));
    if (isTimeEmpty || (this.escortConfig.disableMarshallInDayHours && timeInRange) || !this.escortConfig.disableMarshallInDayHours )
    {
      this.isInTimeRange = true;
    }
    else
    {
      this.isInTimeRange = false;
    }
    this.checkEscortState();
  }

  checkEscortState()
  {
    if ( this.escortConfig.escortAssignment)
    {
      if (this.escortConfig.autoEscortAssignment)
      {
        this.escortAutoAssigner();
      }
      else
      {
        this.isEscortDisabled = !((this.isBookingTypePresent && this.isInTimeRange && this.isCityPresent));
        if (this.isEscortDisabled) {
        this.formDetails.get('guardReq').setValue(false);
        }
      }
    }

  }

   setEscortEnabled(enabled: boolean): void {
    this.isEscortDisabled = enabled;
    this.formDetails.get('guardReq').setValue(enabled);
  }

  showToast(duration: number): void {
    this.toastTimer = true;
    setTimeout(() => this.toastTimer = false, duration);
  }
  handleCityChange()
  {
    let bookingType=this.formDetails.get('spotBookingType').value
    let city=this.formDetails.get('city')?.value
    if(bookingType?.length>0)
    {
      this.getTransPortData(city,bookingType)
    }
  }

  getTransPortData(city:string,bookingType:string)
  {
    this.isLoading=true;
    this.commonService.getTransportData(city,bookingType).subscribe((res)=>{
      this.cityStationMap=[]
      this.isLoading=false;
      res.forEach((cityStation)=>{
        cityStation.isSaved = true;
        cityStation.isBusRailway = true;
        cityStation.city = city;
        this.cityStationMap.push(cityStation);
      })
    },
    (error)=>{
      this.isLoading=false;
      this.cityStationMap=[];
    }
    )
  }
  toggleToast(){
    this.showHighCapacityPopup=false;
  }

  ngOnDestroy() {
    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export interface EscortAssignmentConfig {
  escortAssignment: boolean;
  disableMarshallInDayHours: boolean;
  city: string[];
  bookingType: string[];
  autoEscortAssignment: boolean;
  escortAssigGenderConfig: EscortAssignmentGenderConfig[];
  preponeTripSheetInHours: number;
  instructions: string[];
}

export interface EscortAssignmentGenderConfig {
  gender: string[];
  escortAssigTimeConfig: EscortAssignmentTimeConfig;
}

export interface EscortAssignmentTimeConfig {
  startTime: string;
  endTime: string;
}
export interface CityBookingTypeData
{
  city: string;
  bookingType: string;
}

